module.exports = __webpack_public_path__ + "static/img/ddad344999fbfcf914d673342b0e3b90154daa74.021e1bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/live/ddad344999fbfcf914d673342b0e3b90154daa74.png
// module id = TQkX
// module chunks = 56